import { useEffect, useState } from 'react';

import Loading from "../../components/Loading";
import Data from '../../../repository';
import styles from '../../../styles/Admin.module.scss';
import { Link } from 'react-router-dom';

const formatMoney = (amount) => `£${(Number(amount || 0) / 100).toFixed(2)}`;

function List() {
	const [loading, setLoading] = useState(true);
	const [walletPackages, setWalletPackages] = useState([]);
	const [showArchived, setShowArchived] = useState(false);
	const [updatingId, setUpdatingId] = useState(null);

	const refreshPackages = async () => {
		setLoading(true);
		try {
			const result = await Data.fetchWalletPackages();
			const items = (result.data || []).filter((item) => showArchived ? item.archived : !item.archived);
			setWalletPackages(items);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		refreshPackages();
	}, [showArchived]);

	const updateStatus = async (_id, updates) => {
		setUpdatingId(_id);
		try {
			await Data.updateWalletPackage({ _id, ...updates });
			await refreshPackages();
		} finally {
			setUpdatingId(null);
		}
	};

	if (loading) return <Loading button={false} />;

	return (
		<div className={styles.list}>
			<div className={styles.actions}>
				<button type="button" className={showArchived ? "btn btnEmpty" : "btn btnPrimary"} onClick={() => setShowArchived(false)}>
					Active
				</button>
				<button type="button" className={showArchived ? "btn btnPrimary" : "btn btnEmpty"} onClick={() => setShowArchived(true)}>
					Archived
				</button>
			</div>

			{!walletPackages.length ? <div><p>There aren't any wallet packages to show.</p></div> : null}

			{!!walletPackages.length ? (
				<div className={styles.tableWrap}>
					<table className={styles.table}>
						<thead>
							<tr>
								<th>Package</th>
								<th>Customer Pays</th>
								<th>Wallet Credit</th>
								<th>Sort Order</th>
								<th>Status</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{walletPackages.map((walletPackage) => (
								<tr key={walletPackage._id} className={!walletPackage.enabled ? styles.disabledRow : ''}>
									<td>
										<Link to={walletPackage._id} className={styles.tableLink}>
											{walletPackage.name}
										</Link>
										{walletPackage.description ? <p>{walletPackage.description}</p> : null}
									</td>
									<td>{formatMoney(walletPackage.purchaseAmount)}</td>
									<td>{formatMoney(walletPackage.creditAmount)}</td>
									<td>{walletPackage.sortOrder || 0}</td>
									<td>{walletPackage.enabled ? 'Enabled' : 'Disabled'}</td>
									<td className={styles.tableActions}>
										{!walletPackage.archived ? (
											<button
												type="button"
												className={walletPackage.enabled ? "btn btnEmpty" : "btn btnPrimary"}
												onClick={() => updateStatus(walletPackage._id, { enabled: !walletPackage.enabled })}
												disabled={updatingId === walletPackage._id}
											>
												{updatingId === walletPackage._id ? 'Updating...' : walletPackage.enabled ? 'Disable' : 'Enable'}
											</button>
										) : null}
										<button
											type="button"
											className={walletPackage.archived ? "btn btnPrimary" : "btn btnDanger"}
											onClick={() => updateStatus(walletPackage._id, { archived: !walletPackage.archived })}
											disabled={updatingId === walletPackage._id}
										>
											{updatingId === walletPackage._id ? 'Updating...' : walletPackage.archived ? 'Restore' : 'Archive'}
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			) : null}
		</div>
	);
}

export default List;
